import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import useWidthChange from "./hooks/useWidthChange";
import styled from "@emotion/styled";
import EXHiResLogo from "../images/EXHiResLogo";
import PlatformSelector from "./PlatformSelector";
import ButtonBase from "@mui/material/ButtonBase";
import Navigation from "./Navigation";
import ContactBtn from "./ContactBtn";
import { heightBreakpoints, forSize } from "../utils/sizeMixins";
import { recordEvent, Events } from "../analytics";

const StyledNavbarContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    > *:nth-of-type(2) {
        flex-grow: 1; /* This will make the middle section take up the available space */
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
`;

const StyledNavbarHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    padding: 1em 2em 1em 2em;

    ${forSize(heightBreakpoints.small, 'down', 'y')} {
        padding: 0;
    }
`;

const StyledLogo = styled(ButtonBase)`
    margin: 2rem 3rem;
    padding: 0.5rem;
    border-radius: 0.5rem;

    ${forSize(heightBreakpoints.small, 'down', 'y')} {
        margin: 1.5rem 3rem 1rem 3rem;
    }
`;

const Navbar = () => {
    const [switchWidth, setSwitchWidth] = useState(null);
    const navRef = useRef(null);
    const didMount = useRef(false);

    const computeSwitchWidth = (width) => width * 0.28;

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
    }, []);

    useEffect(() => {
        if (navRef.current) {
            const width = navRef.current.offsetWidth;
            setSwitchWidth(computeSwitchWidth(width));
        }
    }, []);

    useWidthChange(navRef, (width) => {
        setSwitchWidth(computeSwitchWidth(width));
    });

    const exHomeLink = () => {
        recordEvent(Events.NAVIGATE_EXTERNAL_EIGENX_HOME);
        if (typeof window !== "undefined") {
            window.open("https://www.eigenx.com/data-visualization", "_blank");
        }
    }

    return didMount && (
        <StyledNavbarContainer ref={navRef}>

            <StyledNavbarHeader>
                <StyledLogo onClick={exHomeLink}>
                    <EXHiResLogo />
                </StyledLogo>
                {/* Hidden until PBI in testing */}
                {/* {switchWidth !== null && (
                    <PlatformSelector onChange={(state) => console.log(state)} width={switchWidth} />
                )} */}
            </StyledNavbarHeader>

            <Navigation />

            <ContactBtn />
        </StyledNavbarContainer>
    );
};

export default Navbar;
